import Carpooling1 from '../assets/projects/carpooling_web/carpooling1.PNG'
import Carpooling2 from '../assets/projects/carpooling_web/carpooling2.PNG'
import Carpooling3 from '../assets/projects/carpooling_web/carpooling3.PNG'
import Carpooling4 from '../assets/projects/carpooling_web/carpooling4.PNG'
import Carpooling5 from '../assets/projects/carpooling_web/carpooling5.PNG'
import Carpooling6 from '../assets/projects/carpooling_web/carpooling6.PNG'
import Carpooling7 from '../assets/projects/carpooling_web/carpooling7.PNG'
import Carpooling_Trip from '../assets/projects/carpooling_web/trip_Validation.gif'
import Carpooling_Reporting from '../assets/projects/carpooling_web/reporting.gif'
import Home_Page from '../assets/projects/carpooling_web/home_page.gif'

import Carpooling_mobile1 from '../assets/projects/carpooling_Mobile/carp_mobile1.PNG'
import Carpooling_mobile2 from '../assets/projects/carpooling_Mobile/carp_mobile2.PNG'
import Carpooling_mobile3 from '../assets/projects/carpooling_Mobile/carp_mobile_cards.gif'
import Carpooling_mobile4 from '../assets/projects/carpooling_Mobile/carp_mobile_booking_account.gif'
import Carpooling_mobile5 from '../assets/projects/carpooling_Mobile/carp_mobile_messenger.gif'
import Carpooling_mobile6 from '../assets/projects/carpooling_Mobile/carp_mobile_booking_reporting.gif'
import Carpooling_mobile7 from '../assets/projects/carpooling_Mobile/carp_mobile_geolocalisationn.jpg'
import Carpooling_mobile8 from '../assets/projects/carpooling_Mobile/carp_mobile_splash.gif'
import Carpooling_mobile9 from '../assets/projects/carpooling_Mobile/carp_mobile2_firebase_notification.gif'


import docPlanner1 from '../assets/projects/DocPlanner/docPlanner1.PNG'
import docPlanner2 from '../assets/projects/DocPlanner/docPlanner.gif'

import dashboard1 from '../assets/projects/React_Dashboard/dashboard.PNG'
import dashboard2 from '../assets/projects/React_Dashboard/Dashboard.gif'

import ciniphilia1 from '../assets/projects/Cinephilia_Angular7/ciniphilia_ang1.PNG'
import ciniphilia2 from '../assets/projects/Cinephilia_Angular7/ciniphilia_ang_home.gif'
import ciniphilia3 from '../assets/projects/Cinephilia_Angular7/ciniphilia_ang_signup.gif'
import ciniphilia4 from '../assets/projects/Cinephilia_Angular7/ciniphilia_ang_platform.gif'

import Recrutement_Management1 from '../assets/projects/Recrutement_Management/recrutement_manag1.PNG'
import Recrutement_Management2 from '../assets/projects/Recrutement_Management/recutment_candidate.gif'
import Recrutement_Management3 from '../assets/projects/Recrutement_Management/recutment_users.gif'
import Recrutement_Management4 from '../assets/projects/Recrutement_Management/recutment_Eval.gif'

import ciniphilia_react1 from '../assets/projects/ciniphilia_react/ciniphilia_react.PNG'
import ciniphilia_react2 from '../assets/projects/ciniphilia_react/ciniphilia_react_home.gif'
import ciniphilia_react3 from '../assets/projects/ciniphilia_react/ciniphilia_react_payment.gif'
import ciniphilia_react4 from '../assets/projects/ciniphilia_react/ciniphilia_react_platform.gif'

import mybook_login from '../assets/projects/my_book/my_book_login.PNG'
import mybook_gif from '../assets/projects/my_book/My_Book.gif'
import mybook_register from '../assets/projects/my_book/my_book_register.PNG'
import mybook_blog from '../assets/projects/my_book/my_book_blog.PNG'
import mybook_mobile from '../assets/projects/my_book/my_book_blog_mobile.PNG'

import edms_login from '../assets/projects/EDMS/login.PNG'
import edms_register from '../assets/projects/EDMS/register.PNG'
import edms_user_space from '../assets/projects/EDMS/user-space.gif'
import edms_admin_space from '../assets/projects/EDMS/Admin-space.gif'
import edms_rh_space from '../assets/projects/EDMS/RH_space.PNG'

const projects = [

    
    {
        title :"Dashboard",
        description : "JavaScript / Java / ReactJS / Redux / Spring Boot / Rest API / Rest API / Movie DB API / HTML5 / CSS3 /JSX " ,
        images : [dashboard1 ,dashboard2],
        link : ""
    },
  
    {
        title :"DocPlanner ",
        description : "JavaScript / ReactJS / HTML5 / CSS3 /JSX " ,
        images : [docPlanner1,docPlanner2],
        link : "https://wejdi-gh.github.io/Docplanner-Clone-with-React/"
    },

    {
        title :"Ciniphilia React",
        description : "JavScript / ReactJS / NodeJS / ExpressJS / Redux / MongoDB /  Rest API /  Movie DB API / HTLM5 / CSS3 / GIT / Bootstrap4 / Ant Design " ,
        images : [ciniphilia_react1 , ciniphilia_react2, ciniphilia_react3, ciniphilia_react4],
        link : ""
    },
    {
        title :"Recrutement Management ",
        description : "TypeScript / Java / Angular7 / Spring Boot / Spring Security / Postgresql / H2 / Rest API / Hibernate / HTLM5 / CSS3 / Material-ui / PrimeNG / GIT / Swagger / Jenkins/ SonarQube / Maven / Docker" ,
        images : [Recrutement_Management1  , Recrutement_Management2 , Recrutement_Management3 , Recrutement_Management4 ],
        link : ""
    },

    {
        title :"Ciniphilia Angular",
        description : "TypeScript / Java / Angular7 / Redux / Spring Boot /  Spring Security / PostgreSQL /  Hibernate / Rest API / Rest API / Movie DB API / HTML5 / CSS3 / Material-ui / PrimeNG" ,
        images : [ciniphilia1 , ciniphilia2 , ciniphilia3 , ciniphilia4 ],
        link : ""
    },
       
    {
        title :"My  Book",
        description : "JavaScript / Java / ReactJS / React Hooks / Spring Boot / Spring Security / Spring Data / JPA  / Swagger / MarinaDB / Rest API / Hibernate / HTLM5/ CSS3 /  Ant Design / GIT" ,
        images : [mybook_login , mybook_gif,mybook_register , mybook_blog , mybook_mobile] ,   
        link : ""
    },
       
    {
        title :"EDMS",
        description : "JavaScript / Java / ReactJS / Spring Boot / Spring Boot Admin / Spring Security / Spring Cloud /  Spring Data / JPA / Postgresql / Rest API / Hibernate / HTLM5/ CSS3 / Ant Design / GIT / Swagger / Jenkins/ SonarQube / Maven / Docker" ,
        images : [edms_login, edms_register, edms_user_space, edms_admin_space, edms_rh_space ],
        link : ""
    },

   
    {
        title :"Carpooling Web",
        description : "JavaScript / Java / ReactJS / Spring Boot / Spring Boot Admin / Spring Security / Spring Cloud /  Spring Data / JPA / Redux / MongoDB / Rest API / Hibernate / HTLM5/ CSS3 /  Bootstrap4 / Ant Design / GIT / WebSocket / Swagger / Jenkins/ SonarQube / Maven / Docker" ,
        images : [Carpooling1 ,Carpooling2,Carpooling3,Carpooling4,Home_Page,Carpooling_Trip,Carpooling5,Carpooling6 ,Carpooling_Reporting,Carpooling7],
        link : "http://carpooling-talanrd.talan.com"
    },
    {
        title :"Carpooling Mobile",
        description : "Cordova / Firebase / JavaScript / Java / Spring Boot / Spring Boot Admin/ Spring Security / Spring Cloud / Spring Data JPA" ,
        images : [Carpooling_mobile1 , Carpooling_mobile8 , Carpooling_mobile2 , Carpooling_mobile3 ,Carpooling_mobile7, Carpooling_mobile4 , Carpooling_mobile5 , Carpooling_mobile6 , Carpooling_mobile9],
        link : ""
    }
]

export default projects